export default "__VITE_ASSET__9d324256__"